import { configureStore } from '@reduxjs/toolkit'
import notificationsReducer from './slices/notificationsSlice'

export default configureStore({
    reducer: {
        notifications: notificationsReducer,
    },
})